import { Component, Input, Output, SimpleChanges, EventEmitter } from '@angular/core';
import {
    PlatformService, LoggingService, TokenService, LocalStorageService,
    NotificationsService, PriceService, AccountService, TeamEvent,
    SiteLayout,
    Ticket,
    SelectableTicket
} from '@varsity/services';
import { BaseComponent } from '@varsity/components';
import { PopoverController, ToastController } from 'ionic-angular';
import { trigger, state, style, animate, transition, keyframes } from '@angular/animations';
import { InAppBrowser } from '@ionic-native/in-app-browser';
/**
 * Generated class for the TicketActionsComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'ticket-actions',
    templateUrl: 'ticket-actions.html',
    animations: [
        trigger("animatePopout", [
            state('hide',
                style({
                    background: '*'
                })),

            state('show',
                style({
                    background: '*'
                })
            ),
            transition('* => show', animate('1000ms', keyframes([
                style({ transform: "scale(1.3)", offset: 0.25 }),
                style({ transform: "scale(1.15)", offset: 0.5 }),
                style({ transform: "scale(1.0)", offset: 0.75 }),
            ])

            ))
        ])
    ]

})
export class TicketActionsComponent extends BaseComponent {

    @Input() public printEnabled: boolean;
    @Input() public validateEnabled: boolean;
    @Input() public transferEnabled: boolean;
    @Input() public textEnabled: boolean;
    @Input() public walletEnabled: boolean;
    @Input() public displayEnabled: boolean;
    @Input() public filterEnabled: boolean;
    @Input() public showValidate: boolean;
    @Input() public showTransfer: boolean;
    @Input() public showText: boolean;
    @Input() public showDisplay: boolean;
    @Input() public showPrint: boolean;
    @Input() public showAddToWallet: boolean;
    @Input() public showFilter: boolean;
    @Input() public numberOfTickets: number;
    @Input() public tickets: any[];

    @Output() public onPrintClicked: EventEmitter<any> = new EventEmitter();
    @Output() public onValidateClicked: EventEmitter<any> = new EventEmitter();
    @Output() public onTransferClicked: EventEmitter<any> = new EventEmitter();
    @Output() public onTextClicked: EventEmitter<any> = new EventEmitter();
    @Output() public onDisplayClicked: EventEmitter<any> = new EventEmitter();
    @Output() public onAddToWalletClicked: EventEmitter<any> = new EventEmitter();
    @Output() public onFilterClicked: EventEmitter<any> = new EventEmitter();

    showIOS: boolean = false;
    animationState: string = "";

    constructor(
        protected platformService: PlatformService,
        protected loggingService: LoggingService,
        protected tokenService: TokenService,
        protected localStorageService: LocalStorageService,
        protected notificationsService: NotificationsService,
        protected priceService: PriceService,
        protected popoverCtrl: PopoverController,
        protected toastCtrl: ToastController,
        protected accountService: AccountService,
        protected iab: InAppBrowser,
    ) {

        super(
            loggingService, tokenService, localStorageService,
            notificationsService, platformService, toastCtrl, popoverCtrl, iab,
            "TicketActionsComponent"
        );

        console.log('Hello TicketActionsComponent Component');
        

        
    }

    ngOnInit() {
        super.ngOnInit();

        this.platformService.platformType$
            .takeUntil(this.componentDestroyed$)
            .subscribe((value) => {
                if (value == "ios") {
                    this.showIOS = true;
                } else {
                    this.showIOS = false;
                }
            });
    }

    ngOnChanges(changes: SimpleChanges) {
        for (let propName in changes) {
            if (propName == "numberOfTickets") {
                let chng = changes[propName];
                let cur = JSON.stringify(chng.currentValue);
                let prev = JSON.stringify(chng.previousValue);
                if (cur !== prev) {
                    this.animationState = "show";
                }
            }

        }
    }

    printClicked() {
        this.onPrintClicked.emit();
    }

    validateClicked() {
        this.onValidateClicked.emit();
    }

    transferClicked() {
        this.onTransferClicked.emit();
    }

    textClicked() {
        this.onTextClicked.emit();
    }

    displayClicked() {
        this.onDisplayClicked.emit();
    }

    filterClicked() {
        this.onFilterClicked.emit();
    }

    goToAddToWallet() {
        this.onAddToWalletClicked.emit();
    }

    finishAnimation(): void {
        this.animationState = 'hide';
    }

    getNumberOfTicketsForTransfer() {
        return (this.tickets as SelectableTicket[]).filter(p => p.IsSelected && p.TicketAccountActions.ShowTransfer).length;
    }
}



// WEBPACK FOOTER //
// ./src/components/ticket-actions/ticket-actions.ts